import AddIcon from '@mui/icons-material/Add';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import TechFetch from '../../../../images/jobBoardsIcons/TechFetch.png';
import { JobBoardDialogHeader } from '../freeJobBoardSetting/FreeJobBoardSetting';

const TechFetchAdd = () => {
  const navigate = useNavigate();
  return (
    <Box bgcolor="white">
      <JobBoardDialogHeader>
        <Grid item xs={6} container columnGap={2}>
          <img src={TechFetch} alt="TechFetch" height="35" />
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
            Tech Fetch
          </WsTypography>
        </Grid>
      </JobBoardDialogHeader>
      <Grid container p={4} rowGap={3}>
        <Grid item xs={12}>
          <WsTypography>
            There are no accounts set up for Tech Fetch Job Board. Configure your Tech Fetch account
            using search credentials.
          </WsTypography>
        </Grid>
        <Grid item xs={12}>
          <WsButton
            startIcon={<AddIcon fontSize="small" />}
            size="large"
            onClick={() => navigate('/job-boards/techFetch-add')}
          >
            Add account
          </WsButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TechFetchAdd;
